import React from "react";
import "@mui/material";
import {Box, CircularProgress, Typography} from "@mui/material";

const FetchLoading = () => {

    return (
        <>
            <Box display='flex' justifyContent='center' alignItems='center' padding="40px">
                <CircularProgress size={"35px"} color={"primary"} thickness={2}/>
                {/*<Typography position='absolute'>Loading</Typography>*/}
            </Box>
        </>
    )
}

export default FetchLoading;